import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import voca from 'voca';
import Link from 'next/link';
import Wrap from '../../depi/sections/Wrap';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import MuiGrid from '@material-ui/core/Grid';
import MuiButton from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import ResultCard from '../../Filter/Card';
import useStores from '../../../utils/useStores';
import { useTheme } from '@material-ui/core/styles';
import { toFilterEntries } from '../../../shared/utils/mapPage';
import GridHidden from '../../GridHidden';

const FundingImage = '/home/DEPI_Sparschwein.jpg';

const FundingSection = () => {
  const theme = useTheme();
  const WHITE = theme.palette.common.white;
  const GREY = theme.palette.grey[100];
  const { dataStore, uiStore } = useStores();
  const page = dataStore.pages.asList.find(
    p => p.uuid === '6ff5c8d5-3ede-425b-a16e-359b3f3d4f0e',
  );

  if (!page) return null;

  const abstract = voca.prune(page.data.abstract || '', 600, ' ...');

  const foerderfibel = dataStore.pages.asList.find(
    p => p.uuid === 'c51c26be-a8f4-4713-85bd-e9ce5a19eab0',
  );
  const linkContext = process.env.NODE_ENV === 'production' ? '/' : `/depi/`;

  return (
    <React.Fragment>
      <Wrap
        noPadding
        maxWidth={800}
        style={{
          background: `linear-gradient(to bottom, ${WHITE} 0%, ${WHITE} 50%, ${WHITE} 50%, ${GREY} 50%, ${GREY} 100%)`,
        }}
      >
        <img src={FundingImage} width="100%" height="auto" />
      </Wrap>
      <Wrap bgcolor="grey.100">
        <Typography variant="h1" data-underline>
          {page.title}
        </Typography>
        <MuiGrid container spacing={2}>
          <GridHidden item smDown md={1} />
          <MuiGrid item xs={12} sm={7} md={6}>
            <Typography variant="h6">{abstract}</Typography>
          </MuiGrid>
          {foerderfibel && (
            <MuiGrid item xs={12} sm={5} md={4}>
              <ResultCard
                context={uiStore.context}
                data={toFilterEntries(foerderfibel)}
              />
            </MuiGrid>
          )}
          <GridHidden item smDown md={1} />
        </MuiGrid>
        <Box textAlign="center" mt={4}>
          <Link
            href={`${linkContext}[...pageId]`}
            as={`${linkContext}foerderprogramme`}
            passHref
          >
            <MuiButton size="large" variant="outlined">
              Mehr zu Förderprogrammen
            </MuiButton>
          </Link>
        </Box>
      </Wrap>
    </React.Fragment>
  );
};

export default observer(FundingSection);
// export default loadPage(FundingSection, '6ff5c8d5-3ede-425b-a16e-359b3f3d4f0e');
